var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onDisplay),expression:"onDisplay"}],staticClass:"pl-0"},[_c('p',{staticClass:"mt-0 mb-0",attrs:{"id":_vm.timezoneName}},[_c('b',[_vm._v(_vm._s(_vm.timezoneName))]),_vm._v(": "+_vm._s(_vm.currentTime)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }